import type { Messages } from "@prop/i18n";
import type en from "../en/shell";

export default {
  brand: "Funded Lime",
  theme: {
    label: "Тема",
    light: "Светлая",
    dark: "Тёмная",
    system: "Системная",
  },
  language: "Язык",
  nav: {
    home: "Главная",
    menu: "Главное меню",
    security: "Безопасность",
    admin: "Админка",
    signOut: "Выйти",
  },
  home: {
    hello: "Здравствуйте, {name}",
    body: "Здесь ваши челлендж-аккаунты, терминал и коуч.",
    secureTitle: "Защитите аккаунт",
    secureBody: "Включите двухэтапную проверку до начала торговли.",
    secureAction: "Настроить",
  },
  errors: {
    generic: "Что-то пошло не так. Попробуйте ещё раз.",
    network: "Нет связи с сервером.",
  },
  loading: "Загрузка…",
  notFound: "Страница не найдена",
} satisfies Messages<typeof en>;
